import api from "api";

const expenses = {
    create: (payload) => {
        return api().post('/events-expenses/', payload);
    },

    get: (slug, page) => {
        return api().get(`/events-expenses/${slug}?page=${page}`);
    },

    getSummary: (slug) => {
        return api().get(`/events-expenses/${slug}/summary`);
    },

    delete: (id) => {
        return api().delete(`/events-expenses/${id}`);
    },
    update: (id, payload) => {
        return api().put(`/events-expenses/${id}`, payload);
    },
};
 
export default expenses;